// Reviews carousel: prev/next arrows + dot pagination.
// Mirrors the logic in meliusly-how-it-works.js's reviews carousel block,
// scoped to the generic sections/meliusly-reviews.liquid instance (there is
// only one reviews-carousel section per page across the templates that use
// this section, so plain document-level selectors are safe here too).
(function () {
  var reviewsTrack = document.querySelector('[data-mel-reviews-track]');
  var reviewCards = reviewsTrack ? Array.prototype.slice.call(reviewsTrack.querySelectorAll('[data-mel-reviews-card]')) : [];
  var reviewDots = Array.prototype.slice.call(document.querySelectorAll('[data-mel-reviews-dot]'));
  var reviewPrev = document.querySelector('[data-mel-reviews-prev]');
  var reviewNext = document.querySelector('[data-mel-reviews-next]');

  function currentReviewIndex() {
    if (!reviewsTrack || !reviewCards.length) return 0;
    var scrollLeft = reviewsTrack.scrollLeft;
    var closest = 0;
    var closestDist = Infinity;
    reviewCards.forEach(function (card, i) {
      var dist = Math.abs(card.offsetLeft - scrollLeft);
      if (dist < closestDist) {
        closestDist = dist;
        closest = i;
      }
    });
    return closest;
  }

  function setActiveDot(index) {
    reviewDots.forEach(function (dot) {
      var active = dot.getAttribute('data-mel-reviews-dot') === String(index);
      dot.classList.toggle('bg-[#0268A0]', active);
      dot.classList.toggle('bg-[#0268A0]/30', !active);
      dot.classList.toggle('hover:bg-[#0268A0]/50', !active);
    });
  }

  function scrollToReview(index) {
    if (!reviewsTrack || !reviewCards[index]) return;
    reviewsTrack.scrollTo({ left: reviewCards[index].offsetLeft, behavior: 'smooth' });
    setActiveDot(index);
  }

  reviewDots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      scrollToReview(parseInt(dot.getAttribute('data-mel-reviews-dot'), 10));
    });
  });
  if (reviewPrev) {
    reviewPrev.addEventListener('click', function () {
      scrollToReview(Math.max(0, currentReviewIndex() - 1));
    });
  }
  if (reviewNext) {
    reviewNext.addEventListener('click', function () {
      scrollToReview(Math.min(reviewCards.length - 1, currentReviewIndex() + 1));
    });
  }
  if (reviewsTrack) {
    var reviewScrollTimer;
    reviewsTrack.addEventListener('scroll', function () {
      clearTimeout(reviewScrollTimer);
      reviewScrollTimer = setTimeout(function () {
        setActiveDot(currentReviewIndex());
      }, 100);
    });
  }
})();
